import * as types from './types';

export function setConfig(appConfig) {
  return {
    type: types.SET_CONFIG,
    data: appConfig,
  };
}

export function setAdmin(admin) {
  return {
    type: types.SET_ADMIN,
    data: admin,
  };
}

export function setAuth(state) {
  return {
    type: types.SET_AUTH,
    data: state
  };
}

export function setOrigin(admin) {
  return {
    type: types.SET_ORIGIN,
    data: admin
  };
}

export function setLoading(loading) {
  return {
    type: types.SET_LOADING,
    data: loading
  };
}

export function setAppProcessing(_processing) {
  return {
    type: types.SET_PROCESSING,
    data: _processing
  }
}

export function setIsPollingApproveNftStatus(state) {
  return {
    type: types.SET_IS_POLLING_APPROVE_NFT_STATUS,
    data: state
  }
}

export function setIsPollingStakeStatus(state) {
  return {
    type: types.SET_IS_POLLING_STAKE_STATUS,
    data: state
  }
}